/* Admin role-based access. Soft roles: they scope what an admin sees in the panel.
   An UNKNOWN or legacy role (e.g. 'admin', undefined) is treated as super_admin so
   existing admins are never locked out — only the explicit scoped roles restrict. */

export type Role = 'super_admin' | 'ops' | 'finance' | 'support';
const KNOWN: Role[] = ['super_admin', 'ops', 'finance', 'support'];

export const ROLES: { value: Role; label: string; desc: string }[] = [
  { value: 'super_admin', label: 'Super Admin', desc: 'Full access, including team management' },
  { value: 'ops',         label: 'Operations',  desc: 'Clients, orders, command center, leads, notifications' },
  { value: 'finance',     label: 'Finance',     desc: 'Pricing, content, analytics & orders' },
  { value: 'support',     label: 'Support',     desc: 'Clients, command center, leads & notifications' },
];
export const ROLE_LABEL = (r?: string) => ROLES.find(x => x.value === r)?.label || 'Admin';

// section → roles allowed. 'all' = every role.
const SECTIONS: Record<string, Role[] | 'all'> = {
  dashboard: 'all', profile: 'all', settings: 'all',
  commandCenter: ['super_admin', 'ops', 'support'],
  analytics: ['super_admin', 'finance'],
  leads: ['super_admin', 'ops', 'support'],
  services: ['super_admin', 'ops', 'finance'],
  compliance: ['super_admin', 'ops'],
  pricing: ['super_admin', 'finance'],
  content: ['super_admin', 'finance'],
  notifications: ['super_admin', 'ops', 'support'],
  audit: ['super_admin', 'finance'],
  team: ['super_admin'],
  raising: ['super_admin', 'ops'],
  partners: ['super_admin', 'ops', 'finance'],
};

export function getRole(): Role {
  try {
    const r = JSON.parse(localStorage.getItem('adminUser') || '{}').role;
    return KNOWN.includes(r) ? r : 'super_admin'; // unknown/legacy → full (no lockout)
  } catch {
    return 'super_admin';
  }
}

export function can(section: string): boolean {
  const allow = SECTIONS[section];
  if (!allow || allow === 'all') return true;
  return allow.includes(getRole());
}
